/* PULLEX Funko experience v1. No network calls, cart writes, or customer data. */
(() => {
  'use strict';
  if (window.PullexFunkoExperience) return;
  const KEY = 'pullex_saved_funko_v1';
  const RETURN_KEY = 'pullex_funko_results_v1';
  const LIMIT = 40;
  let saved = [];
  let persistent = true;
  let dialog;
  let dialogList;
  let opener;
  let queued = false;
  const all = (s, root = document) => Array.from(root.querySelectorAll(s));
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  function localProduct(value) {
    try {
      const u = new URL(value, location.origin);
      if (u.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(u.pathname)) return '';
      return u.pathname;
    } catch (_) { return ''; }
  }
  function safeImage(value) {
    if (!value) return '';
    try { const u = new URL(value, location.origin); return ((u.origin === location.origin && /^https?:$/.test(u.protocol)) || (u.protocol === 'https:' && /(^|\.)shopify(?:cdn)?\.com$/i.test(u.hostname))) ? u.href : ''; } catch (_) { return ''; }
  }
  function cleanItems(items) {
    if (!Array.isArray(items)) return [];
    const seen = new Set();
    return items.filter(i => i && typeof i === 'object').map(i => ({url: localProduct(i.url), title: String(i.title || '').slice(0, 180), image: safeImage(i.image), condition: String(i.condition || '').slice(0, 90)})).filter(i => i.url && i.title && !seen.has(i.url) && seen.add(i.url)).slice(0, LIMIT);
  }
  function readSaved() {
    try { saved = cleanItems(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch (_) { saved = []; persistent = false; }
  }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (_) { persistent = false; } }
  function announce(message) { setText(document.getElementById('pf-funko-status'), message); }
  function itemFrom(node) {
    const root = node.closest('[data-pf-item]');
    if (!root) return null;
    return cleanItems([{url: root.dataset.pfUrl, title: root.dataset.pfTitle, image: root.dataset.pfImage, condition: root.dataset.pfCondition}])[0] || null;
  }
  function updateButtons() {
    all('[data-pf-save]').forEach(button => {
      const item = itemFrom(button);
      if (!item || typeof HTMLDialogElement === 'undefined') return;
      const active = saved.some(i => i.url === item.url);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove ' + item.title + ' from saved Pops' : 'Save ' + item.title);
      setText(button, active ? '♥ Saved' : (button.classList.contains('pf-card-save') ? '♡ Save' : '♡ Save this Pop'));
    });
    all('[data-pf-open-saved]').forEach(button => { if (typeof HTMLDialogElement !== 'undefined') button.hidden = false; });
    all('[data-pf-saved-count]').forEach(node => setText(node, String(saved.length)));
  }
  function make(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }
  function buildDialog() {
    if (dialog || typeof HTMLDialogElement === 'undefined') return;
    dialog = make('dialog', 'pf-saved-dialog');
    dialog.id = 'pf-saved-pops';
    dialog.setAttribute('aria-labelledby', 'pf-saved-title');
    const head = make('div', 'pf-saved-head');
    const title = make('h2', '', 'Saved Pops'); title.id = 'pf-saved-title'; title.tabIndex = -1;
    const close = make('button', 'pf-saved-close', '×'); close.type = 'button'; close.dataset.pfCloseSaved = ''; close.setAttribute('aria-label', 'Close saved Pops');
    head.append(title, close);
    const intro = make('p', 'pf-saved-intro', 'Your picks on this device. Saving doesn’t reserve stock. Open a listing for its current price and availability.');
    const note = make('p', 'pf-storage-note', 'Your browser is allowing saves for this visit only.'); note.dataset.pfStorageNote = ''; note.hidden = true;
    const capacity = make('p', 'pf-storage-note', 'You have 40 Pops saved. Remove one to make room for another.'); capacity.dataset.pfCapacityNote = ''; capacity.hidden = true;
    dialogList = make('ul', 'pf-saved-list'); dialogList.setAttribute('role', 'list');
    const foot = make('div', 'pf-saved-footer');
    const back = make('button', 'pf-action', 'Keep browsing'); back.type = 'button'; back.dataset.pfCloseSaved = '';
    const clear = make('button', 'pf-saved-clear', 'Clear saved list'); clear.type = 'button'; clear.dataset.pfClearSaved = '';
    foot.append(back, clear); dialog.append(head, intro, note, capacity, dialogList, foot); document.body.append(dialog);
    dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus(); });
    dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); });
  }
  function renderSaved() {
    if (!dialogList) return;
    dialogList.replaceChildren();
    if (!saved.length) dialogList.append(make('li', 'pf-saved-empty', 'No Pops saved yet. Tap Save on any Pop to keep it here.'));
    saved.forEach(item => {
      const row = make('li', 'pf-saved-row');
      const image = make('img'); image.alt = ''; image.width = 70; image.height = 80; image.loading = 'lazy'; if (item.image) image.src = item.image; else { image.hidden = true; row.classList.add('pf-saved-row--noimage'); }
      const copy = make('div', 'pf-saved-copy'); const link = make('a', '', item.title); link.href = item.url; copy.append(link);
      if (item.condition) copy.append(make('p', '', item.condition));
      const remove = make('button', 'pf-saved-remove', 'Remove'); remove.type = 'button'; remove.dataset.pfRemoveSaved = item.url; remove.setAttribute('aria-label', 'Remove ' + item.title);
      row.append(image, copy, remove); dialogList.append(row);
    });
    const clear = dialog.querySelector('[data-pf-clear-saved]'); clear.hidden = saved.length === 0;
    dialog.querySelector('[data-pf-storage-note]').hidden = persistent;
    dialog.querySelector('[data-pf-capacity-note]').hidden = saved.length < LIMIT;
  }
  function saveResultsAndLinks() {
    const hub = document.querySelector('[data-pf-hub]');
    if (hub) {
      const base = new URL(hub.dataset.pfCollectionUrl, location.origin);
      const current = new URL(location.href);
      if (current.origin === base.origin && current.pathname.replace(/\/$/, '') === base.pathname.replace(/\/$/, '')) {
        const safe = new URL(base);
        current.searchParams.forEach((value, key) => { if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') safe.searchParams.append(key, value); });
        try { sessionStorage.setItem(RETURN_KEY, safe.pathname + safe.search); } catch (_) {}
        all('[data-pf-filter]', hub).forEach(link => {
          const u = new URL(safe); const key = link.dataset.pfParam; const value = link.dataset.pfValue;
          if (!key || !key.startsWith('filter.') || value == null) return;
          let values = u.searchParams.getAll(key); const active = values.includes(value);
          values = active ? values.filter(v => v !== value) : [...values, value];
          u.searchParams.delete(key);
          values.forEach(selected => u.searchParams.append(key, selected));
          u.searchParams.delete('page');
          link.href = u.pathname + u.search; link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
        const reset = hub.querySelector('[data-pf-reset]');
        if (reset) { const active = !Array.from(safe.searchParams.keys()).some(k => k.startsWith('filter.')); reset.classList.toggle('is-active', active); if (active) reset.setAttribute('aria-current', 'true'); else reset.removeAttribute('aria-current'); }
        all('[data-pf-sort]', hub).forEach(link => { const u = new URL(safe); u.searchParams.set('sort_by', link.dataset.pfSort); u.searchParams.delete('page'); link.href = u.pathname + u.search; });
      }
    }
    const product = document.querySelector('[data-pf-product]');
    if (product) {
      const link = product.querySelector('[data-pf-return]');
      try {
        const base = new URL(product.dataset.pfCollectionUrl, location.origin); const stored = sessionStorage.getItem(RETURN_KEY); const u = stored ? new URL(stored, location.origin) : null;
        if (link && u && u.origin === base.origin && u.pathname.replace(/\/$/, '') === base.pathname.replace(/\/$/, '')) { link.href = u.pathname + u.search; setText(link, '← Back to your results'); }
      } catch (_) {}
      const short = product.querySelector('.pf-title')?.textContent.trim();
      if (short) all('.pullex-sticky-atc__title').forEach(node => setText(node, short));
    }
  }
  function refresh() {
    all('.pf-collector-card[data-pf-item]').forEach(card => {
      if (!card.dataset.pfTitle) return;
      all('.card__heading a', card).forEach(link => { link.title = card.dataset.pfFullTitle || card.dataset.pfTitle; setText(link, card.dataset.pfTitle); });
    });
    updateButtons(); saveResultsAndLinks();
  }
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; refresh(); }); }
  function init() {
    readSaved();
    if (!document.getElementById('pf-funko-status')) { const status = make('p', 'pf-status'); status.id = 'pf-funko-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); document.body.append(status); }
    buildDialog(); refresh();
    document.addEventListener('click', e => {
      if (!(e.target instanceof Element)) return;
      const save = e.target.closest('[data-pf-save]');
      if (save) {
        const item = itemFrom(save); if (!item) return;
        const exists = saved.some(i => i.url === item.url);
        if (exists) saved = saved.filter(i => i.url !== item.url);
        else { if (saved.length >= LIMIT) { opener = save; renderSaved(); dialog?.showModal(); announce('Your saved list is full. Remove a Pop before saving another.'); return; } saved.unshift(item); }
        persist(); updateButtons(); if (dialog?.open) renderSaved(); announce(exists ? 'Removed from saved Pops.' : (persistent ? 'Pop saved on this device.' : 'Pop saved for this visit.')); return;
      }
      const open = e.target.closest('[data-pf-open-saved]');
      if (open && dialog) { opener = open; renderSaved(); if (!dialog.open) dialog.showModal(); return; }
      if (e.target.closest('[data-pf-close-saved]')) { dialog?.close(); return; }
      const remove = e.target.closest('[data-pf-remove-saved]');
      if (remove) { saved = saved.filter(i => i.url !== remove.dataset.pfRemoveSaved); persist(); renderSaved(); updateButtons(); dialog?.querySelector('h2')?.focus(); announce('Removed from saved Pops.'); return; }
      if (e.target.closest('[data-pf-clear-saved]')) { saved = []; persist(); renderSaved(); updateButtons(); dialog?.querySelector('h2')?.focus(); announce('Saved list cleared.'); }
    });
    window.addEventListener('storage', e => { if (e.key === KEY) { readSaved(); updateButtons(); if (dialog?.open) renderSaved(); } });
    window.addEventListener('popstate', schedule); document.addEventListener('shopify:section:load', schedule);
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  }
  window.PullexFunkoExperience = {refresh: schedule};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
